import { Instagram, Facebook, Linkedin, Twitter } from "lucide-react";
import { SITE } from "@/lib/site";

const groups = [
  {
    title: "Company",
    links: [
      { label: "Protection", href: "#protection" },
      { label: "Wealth", href: "#wealth" },
      { label: "Careers", href: "#careers" },
      { label: "Contact", href: "#contact" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span
              aria-label="Green Financials logo"
              className="block h-12 w-12 rounded-md"
              style={{
                backgroundImage: `url(${SITE.logo})`,
                backgroundSize: "550%",
                backgroundPosition: "center 28%",
                backgroundRepeat: "no-repeat",
              }}
            />
            <span className="font-serif text-2xl text-white">{SITE.brand}</span>
          </div>
          <p className="mt-6 text-sm text-gray-500 max-w-md leading-relaxed font-light">
            Modern life insurance and wealth strategies designed for families,
            entrepreneurs, and future agents.
          </p>
          <div className="mt-8 flex items-center gap-3">
            {[Instagram, Facebook, Linkedin, Twitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                data-testid={`footer-social-${i}`}
                className="w-10 h-10 rounded-full border border-white/10 hover:border-rolex/50 hover:bg-rolex/10 flex items-center justify-center text-gray-400 hover:text-rolex-light transition-all duration-300"
                aria-label="social link"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-10">
          {groups.map((g) => (
            <div key={g.title}>
              <div className="text-[11px] uppercase tracking-[0.28em] text-gray-500 mb-5">
                {g.title}
              </div>
              <ul className="space-y-3">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-gray-300 hover:text-white transition-colors"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
        <div className="text-xs text-gray-600 font-light">
          © {new Date().getFullYear()} {SITE.brand}. All rights reserved.
        </div>
        <div className="text-xs text-gray-600 font-light">
          Insurance products offered through licensed professionals.
        </div>
      </div>
    </footer>
  );
}
